// extracted by mini-css-extract-plugin
export var actionButton = "_iq-0";
export var actionMenuContainer = "_iq-i";
export var bubble = "_iq-2";
export var bubbleActionMenu = "_iq-j";
export var bubbleContext = "_iq-6";
export var bubbleItems = "_iq-7";
export var customer = "_iq-3";
export var divider = "_iq-8";
export var fileList = "_iq-9";
export var hiddenComment = "_iq-o";
export var infoAbove = "_iq-a";
export var internal = "_iq-4";
export var lightActionButton = "_iq-1";
export var link = "_iq-b";
export var merchant = "_iq-5";
export var message = "_iq-c";
export var profilePicture = "_iq-e";
export var quillToolbarContainer = "_iq-f";
export var senderDate = "_iq-g";
export var senderDateCustomer = "_iq-h";
export var senderName = "_iq-d";
export var time = "_iq-k";
export var uploadedImage = "_iq-l";
export var username = "_iq-m";
export var xsmall = "_iq-n";